import React, { useEffect } from 'react';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext.jsx';
import ParrotWizardEdit from '../components/ParrotWizardEdit.jsx';

export default function ParrotEdit() {
  const { id } = useParams();
  const { theme } = useTheme();
  const navigate = useNavigate();

  // Redirect to wizard by default
  useEffect(() => {
    navigate(`/parrots/${id}/edit/step1`);
  }, [id, navigate]);
  
  const handleComplete = (result) => {
    // Navigate back to parrots list after successful update
    navigate('/parrots');
  };

  const handleCancel = () => {
    // Navigate back to parrots list
    navigate('/parrots');
  };
  
  return (
    <>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
      <SignedIn>
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <Link 
              to="/parrots" 
              className={`flex items-center gap-2 transition-colors ${
                theme === 'dark' 
                  ? 'text-teal-400 hover:text-teal-300' 
                  : 'text-teal-600 hover:text-teal-700'
              }`}
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Back to Parrots
            </Link>
            <h1 className={`text-3xl font-bold ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}>
              Edit Parrot
            </h1>
          </div>
          
          <div className={`rounded-lg p-6 ${
            theme === 'dark' ? 'bg-gray-900' : 'bg-white border border-gray-200'
          }`}>
            <ParrotWizardEdit 
              parrotId={id} 
              onComplete={handleComplete}
              onCancel={handleCancel}
            />
          </div>
        </div>
      </SignedIn>
    </>
  );
}
